<template>
    <el-date-picker
        size="small"
        type="datetimerange"
        start-placeholder="Mistä"
        end-placeholder="Mihin"
        format="DD.MM.YYYY HH:mm:ss"
        value-format="DD.MM.YYYY HH:mm:ss" />
</template>
